export default __webpack_public_path__ + "static/media/1873.ce38057d.png";